module.exports = __webpack_public_path__ + "static/media/plus-colored.83d63431.svg";